<template>
  <div id="item-template">
    <div
      :name="item.code"
      :class="'map-item' + (selected ? ' selected' : '')"
      @click="select"
    >
      <div class="list-icon">
        <i class="material-icons">local_shipping</i>
      </div>
      <div class="list-content">
        <div class="row">
          <div class="col-12">
            <div class="flex-row">
              <div class="list-header-left">
                <h1>{{ item.code }}</h1>
                <div class="list-route">
                  <div class="list-route-dep">
                    <div class="list-route-icon">
                      <i class="material-icons">place</i>
                    </div>
                    <div class="list-route-content">
                      {{ item.departure && item.departure.hub.cityName }} -
                      <span class="time">
                        {{ item.departure && item.departure.scheduledTime | calendar }}
                      </span>
                    </div>
                  </div>
                  <div class="list-route-arr">
                    <div class="list-route-icon">
                      <i class="material-icons">place</i>
                    </div>
                    <div class="list-route-content">
                      {{ item.arrival && item.arrival.hub.cityName }} -
                      <span class="time">
                        {{ item.arrival && item.arrival.scheduledTime | calendar }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list-header-right">
                <div class="eta">
                  <div class="time">
                    {{
                      item.arrival &&
                        item.arrival.effectiveActualTime | calendarShortFormat
                    }}
                  </div>
                </div>

                <div class="badge badge-grey">
                  <span class="label-status-name">{{ item.shortStatusHuman }}</span>
                  <span class="label-delay">{{ item.delayHuman }}</span>
                  <span class="label-crosshair">
                    <i v-if="item.gpsIsOnline" class="material-icons">gps_fixed</i>
                    <i v-else class="material-icons">gps_not_fixed</i>
                  </span>
                </div>
              </div>
            </div>

            <div class="inline-item list-ref" v-if="referenceNumber">
              <i class="material-icons icon-space">bookmark_border</i>
              <translate class="colon-space">Ref:</translate>
              <span class="black">{{ referenceNumber }}</span>
            </div>
            <div class="inline-item list-id">
              <i class="material-icons icon-space">fingerprint</i>
              <translate class="colon-space">ID:</translate>
              <span class="black">{{ item.id }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="list-right">
        <router-link :to="{ name: 'Transfer', params: { transferId: item.id } }">
          <div>
            <i class="material-icons">keyboard_arrow_right</i>
            <div class="detail-label">detail</div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import baseController from '../../controllers/base'

export default {
  extends: baseController,
  props: ['selectedItem', 'item'],
  computed: {
    selected() {
      return this.item.id === (this.selectedItem && this.selectedItem.id)
    },
    referenceNumber() {
      return (this.item.order && this.item.order.referenceNumber) || ''
    },
    layers() {
      return this.item.layers
    }
  },
  methods: {
    select() {
      return this.$emit('selected', { item: this.item, layers: this.layers })
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/_variables.scss';
</style>

<style scoped>
.icon-space {
  margin-right: 1px;
}
.colon-space {
  margin-right: 4px;
}
</style>

